import React from 'react'

export default function Register() {
  return (
    <div>
      <h1>Register Screen </h1>
    </div>
  )
}
